import { render, staticRenderFns } from "./institutionDialog.vue?vue&type=template&id=522f3a10&scoped=true"
import script from "./institutionDialog.vue?vue&type=script&lang=js"
export * from "./institutionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f3a10",
  null
  
)

export default component.exports